// components/Team.js
import React from 'react';
import ScrollAnimation from './ScrollAnimation';

const Team = () => {
    const teamMembers = [
        {
            id: 1,
            name: "Carolina",
            role: "Abogada",
            bio: "Licenciada en Turismo y Abogada. Garantiza que nuestras soluciones sean eficientes y cumplan con los marcos legales.",
            image: "/images/caro.png",
        },
        {
            id: 2,
            name: "Cecilia",
            role: "Politologa",
            bio: "Politóloga. Ayuda a traducir información compleja en decisiones claras.",
            image: "/images/ceci.png",
        },
        {
            id: 3,
            name: "Lucia",
            role: "Licenciada en trabajo social",
            bio: "Trabajadora social. Aporta la visión social y comunitaria a nuestros desarrollos..",
            image: "/images/luci.png"
        },
        {
            id: 4,
            name: "Nicolas",
            role: "Programador full stack",
            bio: "Desarrollador fullstack, se encarga de construir nuestras plataformas digitales.",
            image: "/images/nico.png"
        },
        {
            id: 5,
            name: "Paula",
            role: "Kinesiologa",
            bio: "Kinesióloga Integra la perspectiva sanitaria en nuestras soluciones.",
            image: "/images/pau.png"
        }
    ];

    return (
        <section className="py-12 bg-gray-50 rounded-2xl mt-8">
            <div className="container mx-auto px-6">
                <ScrollAnimation>
                    <h3 className="text-2xl font-bold font-poppins text-grafito mb-2 text-center">
                        Conoce al equipo
                    </h3>
                    <p className="text-lg text-gray-600 font-lato text-center mb-12 max-w-2xl mx-auto">
                        Los cinco hermanos que combinamos expertise técnico con conocimiento profundo del sector público
                    </p>
                </ScrollAnimation>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-8">
                    {teamMembers.map((member, index) => (
                        <ScrollAnimation key={member.id} delay={0.1 * index}>
                            <div className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden group">

                                <div className="relative h-48 bg-gradient-to-br from-gray-200 to-gray-300 overflow-hidden">
                                    <div className="absolute inset-0 bg-cyan/10 group-hover:bg-cyan/20 transition-colors"></div>
                                    <div className="absolute bottom-4 left-4 right-4 text-center">
                                        <span className="text-xs bg-cyan text-white px-2 py-1 rounded-full font-montserrat">
                                          {member.role}
                                        </span>
                                    </div>

                                    {/* ÁREA DE LA IMAGEN - MODIFICADA */}
                                    <div className="relative h-48 overflow-hidden bg-gray-200">
                                        {member.image ? (
                                            <img
                                                src={member.image}
                                                alt={member.name}
                                                className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-300"
                                                onError={(e) => {
                                                    // Fallback si la imagen no carga
                                                    e.target.style.display = 'none';
                                                }}
                                            />
                                        ) : (
                                            // Placeholder solo si no hay imagen
                                            <div className="flex items-center justify-center h-full bg-gradient-to-br from-gray-300 to-gray-400">
                                                <span className="text-4xl text-gray-600 font-bold">
                                                    {member.name.split(' ').map(n => n[0]).join('')}
                                                </span>
                                            </div>
                                        )}
                                    </div>
                                </div>

                                {/* Contenido */}
                                <div className="p-6">
                                    <h4 className="text-xl font-bold font-poppins text-grafito mb-2 text-center">
                                        {member.name}
                                    </h4>
                                    <p className="text-gray-600 font-lato text-sm mb-4 text-center">
                                        {member.bio}
                                    </p>
                                </div>
                            </div>
                        </ScrollAnimation>
                    ))}
                </div>

                {/* Mensaje final del equipo */}
                <ScrollAnimation delay={0.6}>
                    <div className="text-center mt-12 pt-8 border-t border-gray-200">
                        <p className="text-lg text-grafito font-lato italic">
                            "Cinco disciplinas, una visión: tecnología al servicio del bien común"
                        </p>
                    </div>
                </ScrollAnimation>
            </div>
        </section>
    );
};

export default Team;
